import Vue from 'vue'
import App from '@/models/App'

export default class ShipUserFuzzy extends App {
    static get entity() {
        return 'ShipUserFuzzy'
    }
    static all() {
        return this.query().withAllRecursive().orderBy('id', 'desc').get()
    }
    static fields() {
        return {
            id: this.attr(''),
            maritimeId: this.attr(''),
            firstName: this.attr(''),
            middleName: this.attr(''),
            lastName: this.attr(''),
            job: this.attr(''),
            email: this.attr(''),
            profileImage: this.attr(''),
        }
    }
    get anyMiddleName() {
        return this.middleName ?? ''
    }
    get fullName() {
        return `${this.firstName} ${this.anyMiddleName} ${this.lastName}`
    }
    static apiConfig = {
        actions: {
            fetch(shipId, params) {
                return this.get(`${shipId}/invites/fuzzy`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
